import { render, staticRenderFns } from "./ContectSupport.vue?vue&type=template&id=71022c71&"
import script from "./ContectSupport.vue?vue&type=script&lang=js&"
export * from "./ContectSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports